export { default as ProductDetailWrapper } from './ProductDetailWrapper'
